import React, { Component } from 'react'
import Meta from 'components/layout/Meta';
import {actions} from "components/page/pageModule";

import './index.scss'

class FangAn extends Component {

  constructor(props) {
    super(props)
  }

  render() {

    return (
      <div className="servicesWrap">
        <Meta location={this.props.location} title=""/>
        <div className="banner fa_banner">
          <div className="banner_cont">
            <h1>一站式信贷解决方案</h1>
            <p>为合作机构在个人消费信贷、小微企业贷款等业务场景提供一站式智能信贷解决方案，包括智能科技产品组合、智能获客解决方案和全流程风控技术辅助服务，助力合作机构在系统研发建设、获客、风控等核心环节降本增效，迅速开展业务。</p>
            <a href="./services/submitform">方案咨询</a>
          </div>
        </div>
        <div className="wrapPanel">
          <div className="panel fa_panel">
            <h2><span>智能科技产品组合</span></h2>
            <p>智能科技产品组合覆盖获客、反欺诈、审批决策、账务管理、贷后催收等信贷全流程，融合了大数据、人工智能等前沿技术，可根据合作机构需求在获客、风控、账务、催收等环节提供灵活的系统组合支持，能帮助合作机构以最快最低成本的方式完成系统搭建</p>
            <img src={require('./images/pro_4.png')}/>
          </div>
        </div>
        <div className="wrapPanel fa_wrap">
          <div className="panel fa_panel paddingTop">
            <h2><span>智能获客解决方案</span></h2>
            <p>我们拥有覆盖全国的行销网络， 同时结合完善的线上获客体系，能为合作机构提供涵盖多元化获客矩阵、精准流量触达、精细化营销管理的智能获客解决方案，通过线下覆盖全国的营业网点推荐优质客户，叠加线上的智能营销获客，借助线上线下一体化销售服务体系，实现优质客户广泛触达，助力合作机构高效精准获客。</p>
            <a className="more" href="./services/huoke">了解智能获客</a>
          </div>
        </div>
        <div className="wrapPanel fa_wrap">
          <div className="panel fa_panel paddingTop">
            <h2><span>风控技术辅助</span></h2>
            <p>中腾信与多家权威征信机构合作，并加入中国互联网金融协会信用信息共享平台，充分覆盖各类消费信贷人群的信用数据。通过自主研发的决策引擎系统、反欺诈侦测系统及催收系统，为金融机构提供全流程的风控技术辅助服务。</p>
            <p>可按照合作机构的风控标准，利用业内先进的系统及数据分析手段，排除黑名单、欺诈等风险点，结合申请人的风险评分、决策引擎规则结果、资产负债情况以及审批人员经验，向金融机构推荐符合要求的借款人。</p>
            <a className="more" href="./services/fengkong">了解风控技术辅助</a>
          </div>
        </div>
      </div>
    )
  }
}


export default FangAn



// WEBPACK FOOTER //
// ./modules/services/FangAn.js